import axios from 'axios'

window.TABS = window.TABS || {};
TABS.wizard = (function () {
    return {
        /** Step 1: Identify */
        previousUsername:            null,
        usernameChange:              function (event) {
            if (event.keyCode === 13) {
                TABS.wizard.submitIdentity()
            } else if (TABS.wizard.previousUsername !== event.target.value) {
                TABS.wizard.disableStep2()
                document.querySelectorAll('#identify-password-field').forEach(el => el.classList.add('hide'))
                document.querySelectorAll('#identify-password-field input[type=password]').forEach(el => el.value = '')
                document.querySelectorAll('#toggle-forgot-password-button').forEach(el => el.classList.add('hide'))
                TABS.wizard.previousUsername = event.target.value;

                TABS.booking.setFeedback('');
            }
        },
        submitCallbackOnEnter:       function (event, callback) {
            if (event.keyCode === 13) {
                callback()
            }
        },
        getValueBySelector: function (selector, defaultValue = '') {
            const el = document.querySelector(selector)
            return el ? el.value : defaultValue

        },
        toggleForgotPassword: function () {
            const toggleForgotPasswordButton = document.querySelector('#toggle-forgot-password-button')
            const submitForgotPasswordButton = document.querySelector('#submit-forgot-password-button')
            const submitIdentityButton = document.querySelector('#submit-identity-button')
            const passwordInput = document.querySelector('#identify-password-field')
            TABS.booking.setFeedback('')

            if (submitForgotPasswordButton.classList.contains('hide')) {
                // Forgot password is hidden
                submitForgotPasswordButton.classList.remove('hide')
                submitForgotPasswordButton.textContent = TABS.$t('Send passord')
                submitIdentityButton.classList.add('hide')
                toggleForgotPasswordButton.textContent = TABS.$t('Tilbake')
                passwordInput.classList.add('hide')
            } else {
                // Forgot password is shown, toggle back to login
                submitForgotPasswordButton.classList.add('hide')
                submitIdentityButton.classList.remove('hide')
                toggleForgotPasswordButton.textContent = TABS.$t('Mangler passord?')
                passwordInput.classList.remove('hide')
            }
        },
        submitForgotPassword: function () {
            if (TABS.booking.loading) {
                return;
            }
            TABS.booking.setLoading(true)
            document.querySelectorAll('#submit-forgot-password-button').forEach(el => {
                el.classList.add('disabled')
                el.textContent = TABS.$t('Laster...')
            })
            TABS.booking.request('reset_password', null, TABS.wizard.resetPasswordCallback, {
                username: TABS.wizard.getValueBySelector('#identify-accordion-body input[name=username]')
            })
        },
        resetPasswordCallback: function (res) {
            TABS.booking.setLoading(false)
            document.querySelectorAll('#submit-forgot-password-button').forEach(el => {
                el.classList.remove('disabled')
                el.textContent = TABS.$t('Send passord')
            })
            if (res.status === 'ok') {
                TABS.wizard.toggleForgotPassword()
                TABS.booking.showSuccess(res.html)
            } else {
                TABS.booking.showError(res.message)
            }
        },
        loadingButtons:               null,

        submitIdentity:              function () {
            if (TABS.booking.loading) {
                return;
            }
            TABS.booking.setFeedback('');

            const form = document.querySelector('#identify-accordion-body')
            const totp = TABS.wizard.getValueBySelector('input[name=login_totp]')
            const username = TABS.wizard.getValueBySelector('input[name=username]')
            const password = TABS.wizard.getValueBySelector('input[name=password]')

            if (!username.length) {
                TABS.booking.showError(TABS.$t('Du må angi mobilnummer'));
                return;
            }

            TABS.booking.setLoading(true)
            TABS.wizard.loadingButtons = document.querySelectorAll('#identify-accordion-body .btn-primary');
            TABS.wizard.loadingButtons.forEach(el => el.setAttribute('disabled', 'disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.classList.add('disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.textContent = TABS.$t('Laster...'));
            if (!password.length) {
                return TABS.wizard.checkMobile(username)
            }

            TABS.booking.request('verify_mobile', null, TABS.wizard.verifyMobileCallback, {
                username: username,
                password: password,
                totp:     totp,
            }, 0, TABS.wizard.step1ErrorCallback)
        },

        verifyMobileCallback: function (res) {
            TABS.wizard.loadingButtons.forEach(el => el.removeAttribute('disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.classList.remove('disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.textContent = TABS.$t('Fortsett'));
            TABS.booking.setLoading(false)

            TABS.analytics.triggerAnalyticsEvent(TABS.booking.endpoint, 'authentication', 'Mobile', res.success ? 1 : 0);

            if (res.success) {
                const form = document.querySelector('#identify-accordion-body')
                const totp = TABS.wizard.getValueBySelector('input[name=login_totp]')
                const bookAsStudentForm = document.querySelector('#book-as-student')
                const bookAsContactForm = document.querySelector('#book-student-as-contact')
                const username = TABS.wizard.getValueBySelector('input[name=username]')
                const password = TABS.wizard.getValueBySelector('input[name=password]')

                if (parseInt(totp) === 1) {
                    document.querySelector('#booking-form-inputs input[name=login_hash]').value = password
                    document.querySelector('#booking-form-inputs input[name=skip_contact]').value = ''
                    document.querySelector('#booking-form-inputs input[name=logged_in_user_id]').value = ''

                    bookAsStudentForm.querySelector('input[name=mobile]').value = username
                    bookAsStudentForm.querySelector('input[name=mobile]').setAttribute('readonly', 'readonly')
                    bookAsStudentForm.querySelector('input[name=first_name]').value = ''
                    bookAsStudentForm.querySelector('input[name=first_name]').removeAttribute('readonly')
                    bookAsStudentForm.querySelector('input[name=last_name]').value = ''
                    bookAsStudentForm.querySelector('input[name=last_name]').removeAttribute('readonly')
                    bookAsStudentForm.querySelector('input[name=birth_date]').value = ''
                    bookAsStudentForm.querySelector('input[name=birth_date]').removeAttribute('readonly')
                    bookAsStudentForm.querySelector('input[name=email]').value = ''
                    bookAsStudentForm.querySelector('input[name=email]').removeAttribute('readonly')

                    bookAsContactForm.querySelector('input[name=mobile]').value = username
                    bookAsContactForm.querySelector('input[name=mobile]').setAttribute('readonly', 'readonly')
                    bookAsContactForm.querySelector('input[name=first_name]').value = ''
                    bookAsContactForm.querySelector('input[name=first_name]').removeAttribute('readonly')
                    bookAsContactForm.querySelector('input[name=last_name]').value = ''
                    bookAsContactForm.querySelector('input[name=last_name]').removeAttribute('readonly')
                    bookAsContactForm.querySelector('input[name=birth_date]').value = ''
                    bookAsContactForm.querySelector('input[name=birth_date]').removeAttribute('readonly')
                    bookAsContactForm.querySelector('input[name=email]').value = ''
                    bookAsContactForm.querySelector('input[name=email]').removeAttribute('readonly')
                } else {
                    document.querySelector('#booking-form-inputs input[name=login_hash]').value = ''
                    document.querySelector('#booking-form-inputs input[name=skip_contact]').value = res.data.skip_contact ? '1' : ''
                    document.querySelector('#booking-form-inputs input[name=logged_in_user_id]').value = res.data.user_id

                    bookAsStudentForm.querySelector('input[name=mobile]').value = res.data.mobile
                    bookAsStudentForm.querySelector('input[name=mobile]').setAttribute('readonly', 'readonly')
                    bookAsStudentForm.querySelector('input[name=first_name]').value = res.data.first_name
                    bookAsStudentForm.querySelector('input[name=first_name]').setAttribute('readonly', 'readonly')
                    bookAsStudentForm.querySelector('input[name=last_name]').value = res.data.last_name
                    bookAsStudentForm.querySelector('input[name=last_name]').setAttribute('readonly', 'readonly')
                    bookAsStudentForm.querySelector('input[name=birth_date]').value = res.data.birthdate
                    bookAsStudentForm.querySelector('input[name=birth_date]').setAttribute('readonly', 'readonly')
                    bookAsStudentForm.querySelector('input[name=email]').value = res.data.email
                    bookAsStudentForm.querySelector('input[name=email]').setAttribute('readonly', 'readonly')

                    bookAsContactForm.querySelector('input[name=mobile]').value = res.data.mobile
                    bookAsContactForm.querySelector('input[name=mobile]').setAttribute('readonly', 'readonly')
                    bookAsContactForm.querySelector('input[name=first_name]').value = res.data.first_name
                    bookAsContactForm.querySelector('input[name=first_name]').setAttribute('readonly', 'readonly')
                    bookAsContactForm.querySelector('input[name=last_name]').value = res.data.last_name
                    bookAsContactForm.querySelector('input[name=last_name]').setAttribute('readonly', 'readonly')
                    bookAsContactForm.querySelector('input[name=birth_date]').value = res.data.birthdate
                    bookAsContactForm.querySelector('input[name=birth_date]').setAttribute('readonly', 'readonly')
                    bookAsContactForm.querySelector('input[name=email]').value = res.data.email
                    if (res.data.email) {
                        bookAsContactForm.querySelector('input[name=email]').setAttribute('readonly', 'readonly')
                    } else {
                        bookAsContactForm.querySelector('input[name=email]').removeAttribute('readonly')
                    }
                }

                TABS.wizard.enableStep2()
                if (res.message) {
                    document.querySelectorAll('#logged-in-state .alert-success').forEach(el => el.textContent = res.message)
                    document.querySelectorAll('#logged-in-state .btn-primary').forEach(el => el.textContent = TABS.$t('Logg ut'))
                }
                document.querySelectorAll('#logged-in-state').forEach(el => el.classList.remove('hide'))
                document.querySelectorAll('#logged-out-state').forEach(el => el.classList.add('hide'))
                return;
            }

            TABS.booking.showError(res.message)
        },

        checkMobile: function (username) {
            TABS.booking.request('check_mobile', null, TABS.wizard.checkMobileCallback, {
                username: username
            })
        },

        checkMobileCallback: function (res) {
            TABS.wizard.loadingButtons.forEach(el => el.removeAttribute('disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.classList.remove('disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.textContent = TABS.$t('Fortsett'));
            TABS.booking.setLoading(false)

            if (res.error) {
                TABS.booking.showError(res.error);
                return;
            }

            TABS.booking.showSuccess(res.message)
            const passwordFormGroup = document.querySelector('#identify-password-field')
            const forgotPasswordButton = document.querySelector('#toggle-forgot-password-button')
            const label = res.exists ? TABS.$t('Passord') : TABS.$t('Engangspassord')
            if (res.exists) {
                forgotPasswordButton.classList.remove('hide')
            } else {
                forgotPasswordButton.classList.add('hide')
            }

            passwordFormGroup.classList.remove('hide')
            passwordFormGroup.querySelector('label').textContent = label
            passwordFormGroup.querySelector('input').setAttribute('placeholder', label)

            document.querySelector('input[name=login_totp]').value = res.exists ? '0' : '1'
            document.querySelector('#login_password').focus()
        },

        step1ErrorCallback: function (e) {
            TABS.wizard.loadingButtons.forEach(el => el.removeAttribute('disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.classList.remove('disabled'));
            TABS.wizard.loadingButtons.forEach(el => el.textContent = TABS.$t('Fortsett'));
        },
        /** End Step 1: Identify */

        /** Step 2: User Type select */
        selectUserType: function (element) {
            const selectedValue = element.value
            TABS.wizard.disableStep3();
            if (selectedValue === '') {
                return;
            }
            console.log('Selected user type', selectedValue)
            switch (selectedValue) {
                case '0':
                    TABS.wizard.showRegisterAsStudentForm();
                    break;
                case '2':
                    TABS.wizard.showRegisterStudentAsContactForm();
                    break;
            }

            TABS.wizard.enableStep3(selectedValue)
        },

        showRegisterAsStudentForm: function () {
            TABS.analytics.triggerAnalyticsEvent(TABS.booking.endpoint, 'user-select', 'Student');
            document.querySelector('#book-as-student').classList.remove('hide')
            const studentEmailInput = document.querySelector('#book-as-student input[name=email]')
            if (studentEmailInput) {
                if (studentEmailInput.value) {
                    studentEmailInput.setAttribute('readonly', 'readonly')
                } else {
                    studentEmailInput.removeAttribute('readonly')
                }
            }
        },

        showRegisterStudentAsContactForm: function () {
            TABS.analytics.triggerAnalyticsEvent(TABS.booking.endpoint, 'user-select', 'Contact');
            document.querySelector('#book-student-as-contact').classList.remove('hide')

            // If authenticated user exists - we need contact fields to be readonly
            // If authenticated user does not exist - we need contact fields to be editable
            // Consider the fact that authenticated user might've already created a student with contact already, and the user is now creating a new student with contact
            // First we ensure the student fields are hidden
            document.querySelector('#book-student-as-contact input[name=student_mobile]').value = ''
            TABS.wizard.getStudentInfo()

            if (document.querySelector('#booking-form-inputs input[name=login_hash]').value) {
                // No user exists yet - only contact mobile field is readonly
                document.querySelectorAll('#book-student-as-contact input:not([name=mobile])').forEach(input => input.removeAttribute('readonly'))
            } else {
                // Logged in user exists - all contact fields are readonly
                document.querySelectorAll('#book-student-as-contact input:not([name=student_mobile])').forEach(input => input.setAttribute('readonly', 'readonly'))
                const contactEmailInput = document.querySelector('#book-student-as-contact input[name=email]')
                if (contactEmailInput) {
                    if (contactEmailInput.value) {
                        contactEmailInput.setAttribute('readonly', 'readonly')
                    } else {
                        contactEmailInput.removeAttribute('readonly')
                    }
                }
            }
        },
        /** End Step 2: User Type select */

        /** Step 3: Register */
        previousStudentInfoMobile: '',
        // Only ran when registering student as contact (logged in user is the contact)
        getStudentInfo: function (postRegister) {
            const studentMobile = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=student_mobile]')

            if (studentMobile === TABS.wizard.previousStudentInfoMobile && !postRegister) {
                // Mobile value unchanged. Don't rerun request
                return;
            }
            TABS.wizard.previousStudentInfoMobile = studentMobile

            const validMobile = TABS.L10n.phone.parse(studentMobile).validate()
            if (validMobile.length) {
                document.querySelector('#student-input-fields').classList.add('hide')
                document.querySelector('#trigger-confirm-booking').classList.add('hide')
                document.querySelector('#trigger-student-lookup').classList.remove('hide')
                return;
            }
            if (TABS.booking.loading) {
                return;
            }

            TABS.booking.setFeedback('');
            TABS.booking.setLoading(true)

            TABS.booking.request('is_registered', null, function (res) {
                TABS.booking.setLoading(false)
                if (!res.success) {
                    TABS.booking.showError(res.message);
                    return;
                }

                if (studentMobile !== TABS.wizard.getValueBySelector('#book-student-as-contact input[name=student_mobile]')) {
                    // Mobile has changed since call was ran - don't display response
                    return
                }

                if (res.exists) {
                    document.querySelector('input[name=student_user_id]').value = res.data.student_id
                    document.querySelector('input[name=student_first_name]').value = res.data.first_name
                    document.querySelector('input[name=student_first_name]').setAttribute('readonly', 'readonly')
                    document.querySelector('input[name=student_last_name]').value = res.data.last_name
                    document.querySelector('input[name=student_last_name]').setAttribute('readonly', 'readonly')
                    document.querySelector('input[name=student_birth_date]').value = res.data.birth_date
                    document.querySelector('input[name=student_birth_date]').setAttribute('readonly', 'readonly')
                    document.querySelector('input[name=student_email]').value = res.data.email
                    if (res.data.email) {
                        document.querySelector('input[name=student_email]').setAttribute('readonly', 'readonly')
                    } else {
                        document.querySelector('input[name=student_email]').removeAttribute('readonly')
                    }
                } else {
                    document.querySelector('input[name=student_user_id]').value = ''
                    document.querySelector('input[name=student_first_name]').value = ''
                    document.querySelector('input[name=student_first_name]').removeAttribute('readonly')
                    document.querySelector('input[name=student_last_name]').value = ''
                    document.querySelector('input[name=student_last_name]').removeAttribute('readonly')
                    document.querySelector('input[name=student_birth_date]').value = ''
                    document.querySelector('input[name=student_birth_date]').removeAttribute('readonly')
                    document.querySelector('input[name=student_email]').value = ''
                    document.querySelector('input[name=student_email]').removeAttribute('readonly')
                }
                document.querySelector('#student-input-fields').classList.remove('hide')
                document.querySelector('#trigger-confirm-booking').classList.remove('hide')
                document.querySelector('#trigger-student-lookup').classList.add('hide')
            }, { mobile: studentMobile })
        },

        showTermsStep:             function () {
            document.querySelector('#register-accordion-header .fa-check-circle-o').classList.remove('hide')
            document.querySelector('#confirm-and-complete-accordion-header .accordion-button').removeAttribute('disabled')
            document.querySelector('#confirm-and-complete-accordion-header .accordion-button').click()
        },

        registerOrNavigateToConfirm: function () {
            if (TABS.booking.loading) {
                return;
            }

            TABS.booking.setFeedback('');

            const studentId = TABS.wizard.getValueBySelector('input[name=student_user_id]')
            const vippsUserDetailsId = TABS.wizard.getValueBySelector('input[name=contact_vipps_user_id]')

            const bookingAsStudent = !document.querySelector('#book-as-student').classList.contains('hide')

            const postData = {
                office_id:         TABS.wizard.getValueBySelector('#booking-form-inputs input[name=office_id]'),
                class_id:          TABS.wizard.getValueBySelector('#booking-form-inputs input[name=class_id]'),
                course_id:         TABS.wizard.getValueBySelector('#booking-form-inputs input[name=course_id]'),
                ysk_location_id:   TABS.wizard.getValueBySelector('#booking-form-inputs input[name=ysk_location_id]'),
                event_start:       TABS.wizard.getValueBySelector('#booking-form-inputs input[name=event_start_time]'),
                user_type:         TABS.wizard.getValueBySelector('#booking-type-select-accordion-body select[name=user-type]'),
                logged_in_user_id: TABS.wizard.getValueBySelector('#booking-form-inputs input[name=logged_in_user_id]'),
                login_hash:        TABS.wizard.getValueBySelector('#booking-form-inputs input[name=login_hash]'),
            }

            if (bookingAsStudent) {
                postData.student_vipps_user_details_id = vippsUserDetailsId;

                postData.student_mobile = TABS.wizard.getValueBySelector('#book-as-student input[name=mobile]');
                postData.student_first_name = TABS.wizard.getValueBySelector('#book-as-student input[name=first_name]');
                postData.student_last_name = TABS.wizard.getValueBySelector('#book-as-student input[name=last_name]');
                postData.student_birth_date = TABS.wizard.getValueBySelector('#book-as-student input[name=birth_date]');
                postData.student_email = TABS.wizard.getValueBySelector('#book-as-student input[name=email]');

                postData.contact_mobile = TABS.wizard.getValueBySelector('#book-as-student input[name=contact_mobile]');
                postData.contact_first_name = TABS.wizard.getValueBySelector('#book-as-student input[name=contact_first_name]');
                postData.contact_last_name = TABS.wizard.getValueBySelector('#book-as-student input[name=contact_last_name]');
                postData.contact_birth_date = TABS.wizard.getValueBySelector('#book-as-student input[name=contact_birth_date]');
                postData.contact_email = TABS.wizard.getValueBySelector('#book-as-student input[name=contact_email]');
            } else {
                postData.student_id = studentId;
                postData.contact_vipps_user_details_id = vippsUserDetailsId;
                postData.student_mobile = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=student_mobile]');
                postData.student_first_name = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=student_first_name]');
                postData.student_last_name = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=student_last_name]');
                postData.student_birth_date = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=student_birth_date]');
                postData.student_email = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=student_email]');

                postData.contact_mobile = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=mobile]');
                postData.contact_first_name = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=first_name]');
                postData.contact_last_name = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=last_name]');
                postData.contact_birth_date = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=birth_date]');
                postData.contact_email = TABS.wizard.getValueBySelector('#book-student-as-contact input[name=email]');
            }

            TABS.booking.setLoading(true)
            document.querySelector('#register-accordion-body .btn-primary').classList.add('disabled')
            TABS.booking.request('register_student_with_contact', null, function (res) {
                TABS.booking.setLoading(false)
                document.querySelector('#register-accordion-body .btn-primary').classList.remove('disabled')
                TABS.analytics.triggerAnalyticsEvent(TABS.booking.endpoint, 'register', 'Student Info', res.success ? 1 : 0);
                if (res.success) {
                    document.querySelector('#booking-form-inputs input[name=student_id]').value = res.data.student_id
                    document.querySelector('#booking-form-inputs input[name=contact_id]').value = res.data.contact_id

                    // After successful registration, we need to ensure the fields are readonly
                    const bookingAsStudent = !document.querySelector('#book-as-student').classList.contains('hide')
                    if (bookingAsStudent) {
                        document.querySelectorAll('#book-as-student input').forEach(input => input.setAttribute('readonly', 'readonly'))
                    } else {
                        // Student mobile field doesn't need to be read only, so you can navigate back and chose a different student
                        document.querySelectorAll('#book-student-as-contact input:not([name=student_mobile])').forEach(input => input.setAttribute('readonly', 'readonly'))
                    }

                    TABS.wizard.getStudentInfo(true)
                    TABS.wizard.showTermsStep()
                    TABS.wizard.enableStep4()
                    return;
                }
                if (res.require_contact) {
                    document.querySelector('#contact-info').classList.remove('hide')
                    document.getElementById('contact-info').scrollIntoView({ behavior: "smooth" })
                }

                TABS.booking.showError(res.message)
            }, postData)
        },
        /** End Step 3: Register */

        /** Step 4: Confirm and Complete */
        confirmBooking:              function () {
            if (TABS.booking.loading) {
                return;
            }

            TABS.booking.setFeedback('');
            TABS.booking.setLoading(true)

            if (TABS.booking.requirePayment) {
                TABS.booking.loginCallbackLabel = 'Approve terms and proceed to payment' // Analytics label
                TABS.booking.request('login', document.querySelector('#booking-type-select'), TABS.booking.loginCallback);
            } else {
                TABS.booking.loginCallbackLabel = 'Approve terms and complete' // Analytics label
                TABS.booking.request('do_booking', document.querySelector('#booking-type-select'), TABS.booking.loginCallback);
            }
        },
        /** End Step 4: Confirm and Complete */

        /** Helper functions */
        enableStep2: function () {
            TABS.wizard.disableStep3()
            document.querySelectorAll('#user-type').forEach(el => el.value = '')
            document.querySelectorAll('#identify-accordion-header .accordion-button .fa-check-circle-o').forEach(el => el.classList.remove('hide'))
            document.querySelectorAll('#booking-type-select-accordion-header .accordion-button').forEach(el => el.removeAttribute('disabled'))
            document.querySelector('#booking-type-select-accordion-header .accordion-button').click()
        },
        enableStep3: function (userType) {
            TABS.wizard.disableStep4()
            TABS.booking.setFeedback('');
            document.querySelectorAll('#booking-type-select-accordion-header .accordion-button .fa-check-circle-o').forEach(el => el.classList.remove('hide'))
            document.querySelectorAll('#register-accordion-header .accordion-button').forEach(el => el.removeAttribute('disabled'))
            if (document.querySelector('#booking-form-inputs input[name=skip_contact]').value && userType === '0') {
                // User is logged in and registering as student and does not require contact
                TABS.wizard.registerOrNavigateToConfirm()
            } else {
                document.querySelector('#register-accordion-header .accordion-button').click()
            }
        },
        enableStep4: function () {
            document.querySelectorAll('#register-accordion-header .fa-check-circle-o').forEach(el => el.classList.remove('hide'))
            document.querySelectorAll('#confirm-and-complete-accordion-header .accordion-button').forEach(el => el.removeAttribute('disabled'))
            document.querySelector('#confirm-and-complete-accordion-header .accordion-button').click()
        },

        disableStep2: function () {
            document.querySelectorAll('#identify-accordion-header .accordion-button .fa-check-circle-o').forEach(el => el.classList.add('hide'))
            document.querySelectorAll('#booking-type-select-accordion-header .accordion-button').forEach(el => el.setAttribute('disabled', 'disabled'))
            TABS.wizard.disableStep3()
        },
        disableStep3: function () {
            document.querySelectorAll('#booking-type-select-accordion-header .fa-check-circle-o').forEach(el => el.classList.add('hide'))

            document.querySelectorAll('#register-accordion-header .accordion-button').forEach(el => el.setAttribute('disabled', 'disabled'))
            document.querySelectorAll('#register-accordion-header .fa-check-circle-o').forEach(el => el.classList.add('hide'))

            document.querySelectorAll('#book-as-student').forEach(el => el.classList.add('hide'))
            document.querySelectorAll('#book-student-as-contact').forEach(el => el.classList.add('hide'))

            TABS.wizard.disableStep4()
        },
        disableStep4: function () {
            document.querySelectorAll('#confirm-and-complete-accordion-header .accordion-button').forEach(el => el.setAttribute('disabled', 'disabled'))
        }
        /** End Helper functions */
    }
})();